import { Body } from '@hover/blueprint';
import { Flex } from '@hover/blueprint/chakra';
import React from 'react';

import { MaterialButton } from 'src/modules/designStudio/components/DesignMenu/MaterialButton';
import { getMaterialColor } from 'src/modules/designStudio/components/DesignMenu/Menu/TemplateMenu/products/utils';
import type { MaterialGroup } from 'src/modules/designStudio/helpers/productSelection/types';

export const ProductTabletListItem = ({
  material,
  onClick,
}: {
  material: MaterialGroup;
  onClick: () => void;
}) => {
  const variation = material.variation!;
  const colorName = getMaterialColor(material);

  return (
    <MaterialButton
      color={material.appearance.color ?? '#ffffff'}
      isSelected={false}
      maxWidth="184px"
      onClick={onClick}
      thumbnail={variation.thumbnailURL ?? ''}
    >
      <Flex direction="column" my={200}>
        <Body fontWeight={600} my={0} size={400}>
          {variation.product.provider.name}
        </Body>
        <Body color="neutral.600" fontWeight={400} my={0} size={400}>
          {colorName}
        </Body>
      </Flex>
    </MaterialButton>
  );
};
